<template>
  <div>
    <v-menu bottom offset-y>
      <template #activator="{ on }">
        <div class="d-inline-block">
          <v-btn id="import_cred_button" color="primary" class="px-3 text-btn" v-on="on">
            <span class="mr-2">{{ $t('credentials.content.importCredential') }}</span>
            <v-spacer></v-spacer>
          </v-btn>
          <v-btn class="arrow-btn" color="primary" v-on="on">
            <v-icon small>
              mdi-arrow-down
            </v-icon>
          </v-btn>
        </div>
      </template>
      <v-list>
        <v-list-item
          v-for="provider in providers"
          :id="provider.id"
          :key="provider.id"
          @click="handleProviderClick(provider)"
        >
          <v-list-item-content>
            <v-list-item-title class="menu-link">{{ provider.displayName }}</v-list-item-title>
            <v-list-item-subtitle v-if="provider.id === alreadyLoggedProviderId">
              <v-icon small>mdi-check</v-icon>
              {{ $t('credentials.content.connected') }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon class="mr-1 ml-0">
            <v-icon>{{ provider.id === alreadyLoggedProviderId ? 'mdi-cog-outline':'mdi-login' }}</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-list-item

          v-if="evroEnabled" id="import_evro_button"
          to="/credentials/importEvroTrust"
          class="d-flex justify-start"
        >
          <v-list-item-content>
            <v-list-item-title class="menu-link">Evrotrust</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon class="mr-1 ml-0">
            <v-icon>mdi-cog-outline</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <import-alfa-sign v-if="$store.state.remoteConfig.alfaEnabled " @imported="alfaImported" />
      </v-list>
    </v-menu>

    <v-dialog v-model="visibleCredentialDialog" width="30rem">
      <v-card id="import_credentials_root">
        <v-card-title>
          {{ $t('importCredential.externalProviderCredentialsTitle', { providerName: selectedProvider ? selectedProvider.id : "" }) }}
        </v-card-title>
        <v-card-text class="text-center">
          <!-- Loading spinner -->
          <v-progress-circular
            v-if="isLoadingCredentials"
            indeterminate
          ></v-progress-circular>

          <div
            v-for="cred in availableCredentials" v-else
            :key="cred.id"
            class="d-flex align-center"
            style="cursor: pointer;"
          >
            <v-checkbox
              :id="cred.description"
              v-model="selectedCredentials"
              :label="cred.description"
              :value="cred.id"
              class="mr-2"
            />
          </div>
        </v-card-text>
        <v-card-actions class="mt-3">
          <v-btn text :disabled="buttonsDisabled" @click="visibleCredentialDialog = false">
            {{ $t('main.back') }}
          </v-btn>

          <!-- Import button -->
          <v-btn
            id="import_button"
            color="primary"
            :disabled="!selectedCredentials.length || buttonsDisabled"
            @click="importSelectedCredentials"
          >
            {{ $t('importCredential.import') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmationDialog ref="confirmDialog" />
  </div>
</template>

<script>
import ConfirmationDialog from '@/components/ConfirmationDialog.vue'
import ImportAlfaSign from '@/components/alfasign/ImportAlfasign.vue'
import eventBus, { showToastError, showToastSuccess } from '../event-bus'
import credentialRefs from '../services/api/credentialRefs'
import csc from '../services/api/csc'
export default {
  name: 'ImportCredential',
  components: { ConfirmationDialog, ImportAlfaSign },
  emits: ['refreshCredentials'],
  data() {
    return {
      visibleCredentialDialog: false,
      tab: 'providers',
      providers: [],
      selectedCredentials: [],
      availableCredentials: [],
      selectedProvider: undefined,
      selectedCredential: undefined,
      id_token: undefined,
      alreadyLoggedProviderId: null,
      externalProviderLoggedIn: false,
      logoutConfirmation: false,
      clientName: 'web',
      popupLoginWidth: this.$store.state.remoteConfig.popupLogin?.width ?? 770,
      popupLoginHeight: this.$store.state.remoteConfig.popupLogin?.height ?? 720,
      isLoadingCredentials: false,
      evroEnabled: this.$store.state.remoteConfig.evroEnabled ? this.$store.state.remoteConfig.evroEnabled : false,
      buttonsDisabled: false
    }
  },
  // watch: {
  //   async visibleCredentialDialog(val) {
  //     if (!val) {
  //       await this.logoutExternalProvider()
  //     }
  //   }
  // },
  async mounted() {
    this.providers = await credentialRefs.getExternalProviders(this.clientName)

    if (this.providers?.length > 0) {
      const user = await this.$popupAuth.getUser()
      try {
        this.id_token = user ? await this.$popupAuth.getIdToken() : null
        // this.id_token = user ? user.id_token : null
        if (user && !this.id_token) {
          // this.id_token = user.access_token
          this.id_token = await this.$popupAuth.getAccessToken()
        }
      } catch (Err) {
        this.id_token = null
      }
      this.externalProviderLoggedIn = this.id_token != null
      if (this.id_token) {
        this.alreadyLoggedProviderId = this.externalProviderLoggedIn ? this.$store.state.externalProvider?.providerId : null
        if (this.alreadyLoggedProviderId) {
          this.selectedProvider = this.getProviderById(this.alreadyLoggedProviderId)
        }
      } else {
        this.selectedProvider = null
        this.alreadyLoggedProviderId = null
      }
    }
  },
  methods: {
    alfaImported() {
      eventBus.$emit('refreshCredentials')
    },

    handleProviderClick(provider) {
      if (provider.id === this.alreadyLoggedProviderId) {
        this.fetchCredentials(this.resolveBaseURL(provider))
      } else {
        this.loginToProvider(provider)
      }
    },
    async loginToProvider(provider) {
      // 1st step
      const baseURL = this.resolveBaseURL(provider)
      if (!(await this.confirmLogoutIfNeeded(provider))) return null

      const settings = this.buildOidcSettings(provider, baseURL)
      this.$popupAuth.setSettings(settings)

      let user
      try {
        user = await this.$popupAuth.login()
      } catch (err) {
        console.error(err)
        showToastError(this.handleCSCErrorMessage(err))
        return null
      }

      const idToken = user.id_token || user.access_token
      if (!idToken) {
        showToastError(this.$t('importCredential.loginError'))
        return null
      }

      this.id_token = idToken
      this.alreadyLoggedProviderId = provider.id

      this.fetchCredentials(baseURL) // step 2
    },
    async fetchCredentials(baseURL) {
      this.isLoadingCredentials = true
      this.visibleCredentialDialog = true
      try {
        this.selectedCredentials = []
        const { credentialIDs } = await csc.listCredentials(baseURL, this.id_token, {
          maxResults: 100,
          pageToken: null
        })
        this.credentialList = credentialIDs

        const infoPromises = credentialIDs.map(async id => {
          const resp = await csc.credentialsInfo(baseURL, this.id_token, {
            credentialID: id,
            certInfo: null,
            certificates: 'none'
          })
          if (!(resp.key && resp.key.status === 'disabled')) {
            return { id, description: resp.description }
          }
          return null
        })

        const results = await Promise.all(infoPromises)
        this.availableCredentials = results.filter(r => r !== null)
      } catch (err) {
        console.error(err)
        showToastError(this.$t('importCredential.fetchError'))
        this.availableCredentials = []
      } finally {
        this.isLoadingCredentials = false
      }
    },

    /* async importSelectedCredentials() {
      // 3rd
      if (!this.selectedCredentials.length) {
        showToastError(this.$t('importCredential.noCredentialSelectedError'))
        return false
      }

      try {
        this.selectedCredentials.map(async id =>
          credentialRefs.createCredentialRef({
            provider: this.alreadyLoggedProviderId,
            credentialId: id,
            authentication: this.id_token
          })
        )
        console.log('after mpa, hiding dialog')
        this.visibleCredentialDialog = false
        showToastSuccess(this.$t('importCredential.importSucces'))
        this.$emit('refreshCredentials')
        return true
      } catch (err) {
        console.error(err)
        showToastError(this.$t('importCredential.importError'))
        return false
      } finally {
        this.isLoadingCredentials = false
      }
    }, */

    async importSelectedCredentials() {
      if (!this.selectedCredentials.length) {
        showToastError(this.$t('importCredential.noCredentialSelectedError'))
        return false
      }

      try {
        this.buttonsDisabled = true
        await Promise.all(
          this.selectedCredentials.map(async id => {
            try {
              return await credentialRefs.createCredentialRef({
                provider: this.alreadyLoggedProviderId,
                credentialId: id,
                authentication: this.id_token
              })
            } catch (error) {
              throw new Error(this.$t('importCredential.importCredentialError', { id: id, error: error.message }))
            }
          })
        )

        this.visibleCredentialDialog = false
        showToastSuccess(this.$t('importCredential.importSucces'))
        eventBus.$emit('refreshCredentials')
        // await this.logoutExternalProvider()

        return true
      } catch (err) {
        console.error('Import credentials error:', err)
        showToastError(err.message)
        return false
      } finally {
        this.isLoadingCredentials = false
        this.buttonsDisabled = false
      }
    },

    async confirmLogoutIfNeeded(provider) {
      if (!this.alreadyLoggedProviderId || provider.id === this.alreadyLoggedProviderId) {
        return true
      }

      const confirmed = await this.$refs.confirmDialog.openDialog({
        title: this.$t('dialog.externalproviderAlreadyLoggedLogoutConfirmation.title'),
        message: this.$t('dialog.externalproviderAlreadyLoggedLogoutConfirmation.description'),
        yesText: this.$t('main.continue'),
        noText: this.$t('main.no')
      })

      if (confirmed) {
        await this.logoutExternalProvider()
      }

      return confirmed
    },
    buildOidcSettings(provider, baseURL) {
      const { oidc, apiBaseUrl, id } = provider
      const hasCustom = oidc.authorizationEndpoint && oidc.tokenEndpoint && oidc.revocationEndpoint

      const settings = {
        authority: oidc.issuer,
        apiBaseUrl,
        providerId: id,
        client_id: oidc.clientId,
        response_type: 'code',
        scope: oidc.scope,
        prompt: oidc.prompt,
        monitorSession: false,
        popupWindowFeatures: {
          location: false,
          menubar: false,
          toolbar: false,
          height: this.popupLoginHeight,
          width: this.popupLoginWidth,
          closePopupWindowAfterInSeconds: -1
        }
      }

      if (oidc.clientSecret) settings.client_secret = oidc.clientSecret
      if (hasCustom) {
        settings.metadata = {
          authorization_endpoint: oidc.authorizationEndpoint,
          token_endpoint: `${baseURL}/openid/token`,
          revocation_endpoint: oidc.revocationEndpoint
        }
      }

      return settings
    },
    resolveBaseURL(provider) {
      const { oidc, apiBaseUrl, id } = provider
      const hasCustomEndpoints =
      oidc.authorizationEndpoint &&
      oidc.tokenEndpoint &&
      oidc.revocationEndpoint

      return hasCustomEndpoints
        ? this.getExternalProviderRDSSBaseURL(id)
        : apiBaseUrl
    },
    backToParent(e) {
      if (!e) {
        this.$router.go(-1)
      }
    },

    back() {
      this.$router.go(-1)
    },
    getProviderById(id) {
      return this.providers.find(provider => provider.id === id)
    },

    getExternalProviderRDSSBaseURL(providerId) {
      return this.$store.state.remoteConfig.rdssApiUrl + '/v1/extproviders/' + providerId
    },

    handleCSCErrorMessage(error) {
      if (error.message) {
        return this.$t('toastMessage.errorDuringPopupLoginWithDetails', { msg: error.message })
      } else {
        return this.$t('toastMessage.errorDuringPopupLogin')
      }
    },
    async logoutExternalProvider() {
      this.alreadyLoggedProviderId = null
      await this.$popupAuth.logout()
    }

  }
}
</script>
<style scoped>
.d-none {
  display: none;
}
.v-btn-back {
  /*width: 187px;*/
  min-width: 60px !important;
}
.v-btn-done {
  /*width: 187px;*/
  min-width: 90px !important;
}

.text-btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding-right: 2px !important;
}
.arrow-btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0 !important;
  min-width: 35px !important;
  margin-left: 1px;
}</style>
